document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth >= 750) return;

  const sectionId = 'shopify-section-template--26898134171933__section_Pc7amc';
  const section = document.getElementById(sectionId);
  if (!section) return;

  const track = section.querySelector('[data-testid="section-content"]');
  if (!track) return;

  if (track.dataset.carouselInit) return;
  track.dataset.carouselInit = 'true';

  const blocks = Array.from(track.children).filter(function (el) {
    return el.dataset.testid === 'group-block';
  });

  if (blocks.length < 2) return;

  track.classList.add('icons-carousel-active');

  // Cria wrapper externo que agrupa track + dots no fluxo da página
  const outerWrapper = document.createElement('div');
  outerWrapper.className = 'icons-carousel-outer';

  track.parentNode.insertBefore(outerWrapper, track);
  outerWrapper.appendChild(track);

  // Dots dentro do wrapper externo, após o track
  const dotsContainer = document.createElement('div');
  dotsContainer.className = 'icons-carousel-dots';

  blocks.forEach(function (_, i) {
    const dot = document.createElement('button');
    dot.className = 'icons-carousel-dot' + (i === 0 ? ' active' : '');
    dot.setAttribute('aria-label', 'Slide ' + (i + 1));
    dot.addEventListener('click', function () {
      track.scrollTo({ left: track.offsetWidth * i, behavior: 'smooth' });
    });
    dotsContainer.appendChild(dot);
  });

  outerWrapper.appendChild(dotsContainer);

  track.addEventListener('scroll', function () {
    const index = Math.round(track.scrollLeft / track.offsetWidth);
    dotsContainer.querySelectorAll('.icons-carousel-dot').forEach(function (d, i) {
      d.classList.toggle('active', i === index);
    });
  }, { passive: true });
});
